// extracted by mini-css-extract-plugin
export var content = "Modules-module--content--Q4lyn";
export var column = "Modules-module--column--fqIjb";
export var buttons = "Modules-module--buttons--A4cQK";